import Button from "Components/Button";
import { OrderDetails, useOrder } from "hooks/OrderManagement/useOrders";
import { useState } from "react";

type AddNoteProps = {
  data: OrderDetails;
};
const AddNote = ({ data }: AddNoteProps) => {
  const { refetch, updateOrderLoading, updateOrderMutation } = useOrder(
    data?.id
  );
  const [notes, setNotes] = useState(data.notes.join("\n"));

  return (
    <div className="border-[1px] border-[#eee] rounded-md mb-[15px]">
      <p className="border-b-[1px] border-[#eee] py-[20px] px-[15px] font-medium">
        Add Note
      </p>
      <div className="py-[20px] px-[15px]">
        <textarea
          placeholder="Type here"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className="mb-3 py-[20px] px-[15px] h-[200px] rounded-md border-[1px] border-[#eeeeee] resize-none w-full"
        />
        <Button
          disabled={!notes}
          isLoading={updateOrderLoading}
          onClick={() => {
            updateOrderMutation(
              {
                notes,
              },
              {
                onSuccess: () => {
                  refetch();
                  setNotes("");
                },
              }
            );
          }}
          label="Add"
        />
      </div>
    </div>
  );
};

export default AddNote;
